// Build stamp — the id of the bundle the browser is currently running.
//
// REACT_APP_BUILD_ID is set by craco.config.js at build/start time (Vercel's
// VERCEL_GIT_COMMIT_SHA → local git SHA → timestamp fallback) and the SAME id
// is emitted as /version.json by the webpack plugin there. The update poll
// (utils/updateCheck.js) compares the two: served id ≠ this constant means a
// newer deploy is live and this tab is stale. scripts/check-version-stamp.js
// fails the build if the bundle and version.json ever disagree.
export const BUILD_ID = process.env.REACT_APP_BUILD_ID || 'dev';
